import { MediaUploadButton } from "fleet/view/media-library/media-upload-button";
import { connect } from "react-redux";
import { uploadUserContentToS3Action } from "redux-store/user-contents/actions";

function mapDispatchToProps(dispatch) {
  return {
    uploadMedia: (payload) => {
      dispatch(uploadUserContentToS3Action(payload, "Media uploaded!"));
    },
  };
}

const ConnectedMediaUploadButton = connect(
  null,
  mapDispatchToProps,
)(MediaUploadButton);

export { ConnectedMediaUploadButton };
